import React, { useRef, useState } from 'react';
import { Card, Button } from 'react-bootstrap';

import useTranslation from '../../Hooks/UseTranslation';

import './DragAndDropArea.scss';

interface DragDropUploadProps {
  onFileSelected: (file: File) => void;
}

const DragAndDropArea: React.FC<DragDropUploadProps> = ({ onFileSelected }) => {

  const { t } = useTranslation()

  const fileInputRef = useRef<HTMLInputElement>(null);
  const [dragActive, setDragActive] = useState(false);

  const handleDrag = (e: React.DragEvent<HTMLDivElement>) => {
    e.preventDefault();
    e.stopPropagation();
    setDragActive(e.type === 'dragenter' || e.type === 'dragover');
  };

  const handleDrop = (e: React.DragEvent<HTMLDivElement>) => {
    e.preventDefault();
    e.stopPropagation();
    setDragActive(false);
    const file = e.dataTransfer.files?.[0];
    if (file) {
      onFileSelected(file);
    }
  };

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (file) {
      onFileSelected(file);
      e.target.value = ''; // Clear after selection
    }
  };

  const openFileDialog = () => {
    fileInputRef.current?.click();
  };

  return (
    <div
      className={`text-center drag-drop-area ${dragActive ? 'active' : ''}`}
      onDragEnter={handleDrag}
      onDragLeave={handleDrag}
      onDragOver={handleDrag}
      onDrop={handleDrop}
    >
      <input
        type="file"
        accept=".xlsx"
        ref={fileInputRef}
        onChange={handleFileChange}
        style={{ display: 'none' }}
      />
      <p className="mb-3">
        📂 {t('TASK_IMPORTER:DragAndDrop')}
      </p>
      <div>
        <Button className="btn btn-normal-2" onClick={openFileDialog}>
          {t('TASK_IMPORTER:BrowseFiles')}
        </Button>
      </div>
    </div>
  );
};

export default DragAndDropArea;